export default __webpack_public_path__ + "static/media/Dell_logo.fa68c74d.svg";